module.exports = __webpack_public_path__ + "img/viewAllBtn.87e5efe3.svg";